import { createApp } from 'vue'
import Popper from 'vue3-popper'
import Toastify from 'vue3-toastify'

import App from './App.vue'
import router from './router'
import store from './store'

import 'vue3-toastify/dist/index.css'
// last styles file since it includes overrides
import './main.css'

createApp(App)
  .use(store)
  .use(router)
  .use(Toastify, { autoClose: 6000, clearOnUrlChange: false, multiple: false, icon: false })
  .component('Popper', Popper)
  .mount('#app')
